import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Circle from '../circle';
import Map from './map';
import Icon from '@material-ui/core/Icon';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { edos, getEdoName } from '../../funcs/vars';
import { iresults } from '../../funcs/fetch';
import CircularProgress from '@material-ui/core/CircularProgress';


var Chart = require('chart.js');
var ChartLabels = require('chartjs-plugin-datalabels');

export default class Interactivo extends React.Component{

  state = {
    isloading: false,
    hasObj: false,
    results: false,
    showfull: false
  }

  componentDidMount(){
    this.set();
  }

  set(){

  }

  async onSubmit(obj){
    this.setState({
      hasObj: true,
      obj: obj,
      isloading: true
    })

    var r = await iresults(obj);

    scroller.scrollTo('interactivo_data', {
      duration: 500,
      smooth: true,
    })

    this.setState({
      isloading: false,
      results: r
    })

    window.dispatchEvent(new Event('on_fetch'));
    this.props.onFetch(r);
  }


  render(){
    var cs = ['page'];
    if(this.props.active == "interactivo"){
      cs.push('active');
    }

    return(
      <>
      <Element name="interactivo" id="interactivo">
        <div className={cs.join(' ')} id="interactivo">
          {
            this.state.isloading ?
            <div id="interactivo_loader"><div id="interactivo_loader_c"><CircularProgress /></div></div>
            : null
          }
          <div className="page_container">
            <div id="interactivo_box">
              <div id="interactivo_pretitle">Interactivo</div>
              <div id="interactivo_title">
                ¿CÓMO VIVE ALGUIEN COMO YO LOS CONFLICTOS COTIDIANOS EN MÉXICO?
              </div>
              <div id="interactivo_intro">
                <div>
                Este interactivo muestra los resultados del módulo de justicia cotidiana de la Encuesta a Población General del World Justice Project (WJP), que se aplicó a 25,600 mexicanos (800 en cada estado), entre mayo y julio de 2019.
              </div>
              {
                this.state.showfull ?
                <div>
                  <br/>
                Para este análisis se seleccionaron 13 problemas con altas prevalencias de los 38 problemas de justicia cotidiana incluidos en la encuesta. Estos se agruparon en cuatro categorías: laboral (lesiones o problemas de salud causados en el trabajo; un despido injustificado; falta de pagos, salarios atrasados, o problemas para obtener beneficios; y acoso en el trabajo), familiar (dificultades para obtener pagos de manutención o pensión alimenticia para sus hijos; problemas relacionados con la custodia de sus hijos; amenazas o violencia física por parte de su pareja actual, anterior u otro miembro del hogar), consumidor (problemas relacionados con servicios deficientes o mal hechos; problemas para obtener el reembolso de mercancías o productos defectuosos; cortes del servicio de agua potable, luz, teléfono o problemas por facturaciones incorrectas) y cívico (problemas con vecinos sobre límites, bardas o árboles; problemas con sus vecinos por ruido, mascotas, lugares de estacionamiento, etc; problemas con pandillas, vandalismo, o por el consumo de alcohol o drogas en la calle). También, se incluye información acerca de los cuatro tipos distintos de consecuencias que estos problemas causan en la vida de quienes los enfrentan.
              </div>
              : null
              }
              <div id="interactrivo_intro_cta" onClick={() => this.setState({showfull: !this.state.showfull})}>{"Leer " + (this.state.showfull ? 'menos' : 'más')}</div>
              </div>
              <div className="interactivo_datos">

                <Form onSubmit={(obj) => this.onSubmit(obj)}/>
              </div>
            </div>
          </div>
        </div>
      </Element>
      {
        this.state.hasObj ?
        <InteractivoData results={this.state.results} obj={this.state.obj} r={this.state.r} loading={this.state.isloading} />
        : null
      }
      </>
    )
  }
}

class InteractivoData extends React.Component{
  render(){
    return(
      <>
        <Element name="interactivo_data">
          <InteractivoResumen {...this.props}/>

        </Element>
      </>
    )
  }

}

class InteractivoResumen extends React.Component{
  render(){
    return(
      <>
      <div className="page fullpage" id="iresumen">
        <Circle animated dark/>
        <div className="page_container  page_interactivo">
          {
            this.props.results  ?
            <InteractivoResumenData {...this.props} />
            : null
          }

        </div>
      </div>
      <div id="igoto">
        <h1>EXPLORA MÁS CONFLICTOS POR CATEGORÍA</h1>
        A continuación se presenta una mirada con mayor detalle a cada una de las 4 categorías de problemas: laboral, familiar, de consumidor y cívico. En cada sección se presentan los problemas más comunes y sus consecuencias negativas para distintos grupos de la sociedad.
      </div>
      </>
    )
  }
}

export class IR extends React.Component{
  render(){
    var cs = ["page_container_ic_row"];
    if(!this.props.isMain){
      cs.push('page_with_divider');
    }
    return(
      <div className={cs.join(' ')}>
        {
          this.props.content.length ?
          <>
          <div className="page_container_ic_row_td">
            {this.props.content[0]}
          </div>
          {
            this.props.content.length > 1?
              <div className="page_conttainer_ic_row_td">
                {this.props.content[1]}
              </div>
              : null
          }
          </>
          : null
        }
      </div>
    )
  }
}

IR.defaultProps = {
  content: []
}


export class PeopleGraph extends React.Component{
  render(){
    var p = [];
    for(var i = 0; i < this.props.size; i++){
      var cs = ['people_graph_p'];
      if(i < this.props.highlight){
        cs.push('highlighted');
      }
      p.push(<div className={cs.join(' ')}></div>);
    }

    return(
      <div className="people_graph">
        {p}
      </div>
    )
  }
}

PeopleGraph.defaultProps = {
  size: 10,
  highlight: 10
}


class InteractivoResumenData extends React.Component{
  render(){
    var r = this.props.results;
    var obj = this.props.obj;

    /* Primer contenido */
    var fs = [];

    var inc_first = r['general_problem']

    /* Gráfico de impactos */
    var gir = r['incidencia_perfil_row'].impactos;
    var gird = [];
    gir.map(function(gi){
      gird.push([gi.title, parseFloat(gi.v), gi.short]);
    })
    gird = gird.sort((a, b) => a[1] <= b[1] ? 1 : -1);

    var incat = inc_first.type;
    if(incat == 'civico'){
      incat = 'cívico';
    }
    incat = incat.toUpperCase();



    var fs_a = (
                <>
                <div className="icc">
                <div className="icc_category_cover"><img src={require('../../static/cat_cover_0.png')} /></div>
                <div className="icc_title icc_title_hl">
                  El conflicto más común al que se enfrentan personas como tú es:<br/><strong>{inc_first.name}</strong>
                </div>
                <div className="icc_subtitle icc_subtitle_hl">
                  Lo viven
                  &nbsp;<strong>{Math.round(inc_first.value / 10) + " de cada 10 personas"}</strong>
                </div>
                <PeopleGraph highlight={Math.round(inc_first.value / 10)} />
                <div className="icc_title icc_title_hl" style={{marginTop: '1.5rem', marginBottom: '1rem'}}>
                  <strong>El {gird[0][1] +'%'} sufrió una consecuencia negativa* {gird[0][2]} relacionada a un conflicto cotidiano</strong>
                </div>
               </div>
               <div className="icc_subd">
                 *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
               </div>

               </>
              )
    fs.push(fs_a);


    var fs_b = (
                <>

                <GraphLine
                  title="Consecuencias negativas de los conflictos en gente como tú"
                  data={gird}
                  isBar
                  highlight={gird[0][0]}
                  height={320}
                />

               </>
              )
    fs.push(fs_b);


    var stats = r.stats;


    /* Edad */
    var es = [];

    var es_a_keys = Object.keys(stats['impactos_age']);
    var es_a_x = es_a_keys.indexOf(r.age_group);
    var es_a = (
                 <div className="icc">
                  <div className="icc_category">¿A qué se enfrentan las personas de tu edad?</div>
                  <div className="icc_title">
                    De tu grupo de edad, el {Math.round(stats['impactos_age'][r.age_group])}% sufrió al menos una consecuencia negativa* por conflictos cotidianos.
                  </div>

                 </div>
               );
    es.push(es_a);

    var age_sorts = [];
    for(var key in stats['impactos_age']){
      age_sorts.push([key, stats['impactos_age'][key]]);
    }
    age_sorts.sort(function(a, b){
      return a[0] > b[0] ? 1 : -1;
    })
    var es_b = (
                <>
                <div className="icc_subd">
                  *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
                </div>
                <GraphLine
                  highlight={r.age_group}
                  data={age_sorts}
                  isBar
                  height={280}
                />

              </>
              )
    es.push(es_b);

    /* sexo */
    var gs = [];

    var gs_a_keys = Object.keys(stats['impactos_gender']);
    var gs_a_x = gs_a_keys.indexOf(obj.gender);


    var gs_a_subtitle = "";
    if(gs_a_x == 0){
      gs_a_subtitle = "Tu sexo es el que más sufre consecuencias negativas a raíz de un conflicto cotidiano.";
    }

    var gs_plural = obj.gender == "mujer" ? 'las mujeres' : 'los hombres';
    var gs_pp_ = obj.gender == "mujer" ? 'Mujeres' : 'Hombres';

    var gs_a = (
                 <div className="icc">
                  <div className="icc_category">¿Cómo viven {gs_plural} los conflictos cotidianos?</div>
                  <div className="icc_title">
                    El {Math.round(stats['impactos_gender'][obj.gender]) + '%'} de {gs_plural} han sufrido al menos una consecuencia negativa* de un conflicto cotidiano:
                  </div>
                 </div>
               );
    gs.push(gs_a);

    var gender_sorts = [];
    for(var key in stats['impactos_gender']){
      gender_sorts.push([key, stats['impactos_gender'][key]]);
    }
    gender_sorts.sort(function(a, b){
      return a[1] <= b[1] ? 1 : -1;
    })

    var ggs = [];

    gender_sorts.map(function(_g){
      var v = _g[1];
          v = parseInt(v);

      var i = [
        ['No sufre consecuencias', 100 - v],
        ['Sí sufre consecuencias', v]
      ];

      ggs.push(i);
    })

    var ggsi = obj.gender == 'mujer' ? 0 : 1;

    var gs_b = (
                <>
                <div className="icc_subd">
                  *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
                </div>
                <div className="icc_graph icc_graph_flexed">
                  <div className="icc_graph_graphs">
                    <div className="icc_graph_graphs_legends">
                      <div className="icc_graph_graphs_legends_legend">
                        <div
                          style={{background: '#E40F72'}}
                          className="icc_graph_graphs_legends_legend_s"
                        />
                      <div className="icc_graph_graphs_legends_legend_t">{gs_pp_} que sí sufrieron consecuencias</div>
                      </div>
                      <div className="icc_graph_graphs_legends_legend">
                        <div
                          style={{background: 'rgba(240, 1, 67, 0.4)'}}
                          className="icc_graph_graphs_legends_legend_s"
                        />
                      <div className="icc_graph_graphs_legends_legend_t">{gs_pp_} que no sufrieron consecuencias</div>
                      </div>
                    </div>
                    <div className="icc_graph_graphs_g">
                      <GraphDonut
                        highlight={"Sí sufre consecuencias"}
                        data={ggs[ggsi]}
                      />
                    </div>
                  </div>
                </div>

                </>
              )
    gs.push(gs_b);
    var gsfinal = gs;

    /* Estado */
    var gs = [];
    var gse = stats['impactos_edo'];
    var gse_impactos = gse.impactos;
    var gse_incidencias = gse.incidencias;



    var gs_a_keys = Object.keys(gse_impactos);
    var gs_a_x = gs_a_keys.indexOf(obj.edo);

    var edo_fd = [
      ['Sí ha sufrido un conflicto', Math.round(gse_incidencias[obj.edo])],
      ['No ha sufrido un conflicto', 100 - Math.round(gse_incidencias[obj.edo])],
    ]

    var edo_fda = [
      ['Sí ha sufrido una consecuencia', Math.round(gse_impactos[obj.edo])],
      ['No ha sufrido una consecuencia', 100 - Math.round(gse_impactos[obj.edo])],
    ]

    var edoname = getEdoName(obj.edo);

    var edos_bars = [];
    for(var key in gse_impactos){
      var v = gse_impactos[key];
      edos_bars.push([key, parseInt(v)]);
    }

    edos_bars = edos_bars.sort((a, b) => a[1] <= b[1] ? 1 : -1);


    var gs_a = (
                <>
                 <div className="icc">
                    <div className="icc_category">¿Qué pasa en tu entidad?</div>
                      <div className="icc_title">
                        En {edoname} el {Math.round(gse_incidencias[obj.edo]) + '%'} de las personas encuestadas ha sufrido un conflicto*:
                      </div>
                  </div>
                  <div className="icc_subd">
                    *Conflictos cotidianos: despido injustificado, acoso laboral, problemas con vecinos, problemas con pandillas, entre otros.
                  </div>
                  <div className="icc_graph icc_graph_flexed">

                    <div className="icc_graph_graphs">
                      <div className="icc_graph_graphs_g">
                        <GraphDonut
                          highlight={'Sí ha sufrido un conflicto'}
                          data={edo_fd}
                        />
                      </div>
                      <div className="icc_graph_graphs_legends">
                        <div className="icc_graph_graphs_legends_legend">
                          <div
                            style={{background: '#E40F72'}}
                            className="icc_graph_graphs_legends_legend_s"
                          />
                        <div className="icc_graph_graphs_legends_legend_t">Sufrió un conflicto</div>
                        </div>
                        <div className="icc_graph_graphs_legends_legend">
                          <div
                            style={{background: 'rgba(240, 1, 67, 0.4)'}}
                            className="icc_graph_graphs_legends_legend_s"
                          />
                        <div className="icc_graph_graphs_legends_legend_t">No sufrió un conflicto</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="icc">
                    <div className="icc_title">
                      El estado donde hay más consecuencias negativas* a raíz de un conflicto es Chiapas y donde menos es Nuevo León
                    </div>
                  </div>
                  <div className="icc_subd">
                    *Consecuencias negativas: problema financieros, ruptura de relaciones personales, problemas de salud y/o aumento en el consumo de sustancias nocivas.
                  </div>
                  <GraphLine
                    highlight={obj.edo}
                    data={edos_bars}
                    isHorizontal
                    l={"Porcentaje de consecuencias negativas"}
                  />
                  </>

               );
    gs.push(gs_a);


    return(
      <div className="page_container_ic">
        <IR content={fs} isMain/>
        <IR content={es} />
        <IR content={gsfinal} />
        <IR content={gs} />
      </div>
    )
  }
}


export class GraphDonut extends React.Component{
  componentDidMount(){
    var self = this;
    this.set();

    window.addEventListener('on_fetch', function(){
      self.set();
    })
  }

  set(){
    if(this.canvas){
      var ctx = this.canvas;
      if(this.props.height){
        ctx.height = this.props.height;
      }
      ctx = ctx.getContext('2d');

      var colors = this.props.colors;
      if(!colors){
        colors = {
          highlight: [
            'rgba(252, 1, 71, 1)',
            'rgba(128, 81, 241, 1)'
          ],
          normal: [
            'rgba(240, 1, 67, 0.5)',
            'rgba(240, 1, 67, 0.1)'
          ]
        }
      }

      var gradient = colors.normal[0];

      var gradientH = colors.highlight[0];

      var labels = [];
      var data = [];
      var bgs = [];
      var d = this.props.data;
      var highlight = this.props.highlight;
      var m = 0;
      d.map(function(e){
        labels.push(e[0]);
        m = Math.max(m, e[1]);
        data.push(e[1]);
        var bg = gradient;
        if(e[0] == highlight){
          bg = gradientH;
        }
        bgs.push(bg);
      })


      var chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
              data: data,
              backgroundColor:bgs,
              borderColor: 'rgba(240, 1, 67, 0.77)',
              borderWidth: 1
          }]
        },
        options: {
          legend: false,
          aspectRatio: 1,
          borderWidth: 1,
          borderColor: 'red',
          plugins: {
            datalabels: {
              color: '#f6f6f6',
              formatter: function(v, context){
                var index = context.dataIndex;
                var value = context.dataset.data[index];
                return value+'%';
              },
            }
          }
        }
      })


    }
  }

  render(){
    return(
        <div className="icc_graph_canvas icc_graph_canvas_donut">
          <canvas id={"icc_graph_id_" + Math.random(99,99999)} ref={(ref) => this.canvas = ref}></canvas>
        </div>
    )
  }
}


export class GraphLine extends React.Component{
  componentDidMount(){
    var self = this;
    this.set();

    window.addEventListener('on_fetch', function(){
      self.set();
    })
  }

  set(){
    if(this.canvas){

      var labels = [];
      var data = [];
      var bgs = [];
      var d = this.props.data;
      var highlight = this.props.highlight;
      var m = 0;

      var is_desktop = window.innerWidth > 750;

      var ish = this.props.isHorizontal;

      d.map(function(e){
        labels.push(e[0]);
        m = Math.max(m, e[1]);
        data.push(e[1]);
      })

      var multi = is_desktop ? 1.3 : 1;

      if(this.props.isHorizontal){

        var height = labels.length * 11 * multi + (8 * multi);
      }

      var ctx = this.canvas;

      if(this.props.height){
        ctx.height = this.props.height * multi;
      }

      if(this.props.isHorizontal){
        ctx.height = height;
      }

      ctx = ctx.getContext('2d');

      var colors = this.props.colors;
      if(!colors){
        colors = {
          highlight: [
            'rgba(252, 1, 71, 1)',
            'rgba(128, 81, 241, 1)'
          ],
          normal: [
            'rgba(240, 1, 67, 0.5)',
            'rgba(240, 1, 67, 0.1)'
          ],
          clear: '#f0f0f0',
          dark: '#a4a4a4'
        }
      }


      if(this.props.isHorizontal){
        var gradient = colors.normal[0];
        var gradientH = colors.highlight[0];
      }else{
        var gradient = colors.normal[0];
        var gradientH = colors.highlight[0];
      }

      d.map(function(e){
        var bg = gradient;
        if(e[0] == highlight){
          bg = gradientH;
        }
        bgs.push(bg);
      })

      var type = !ish ? 'bar' : 'horizontalBar';

      var bmax = (Math.floor(m / 10) * 10) + 15;

      if(!ish){
        var options = {
        legend: false,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: function(context){
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              var label = labels[index];
              return label == highlight ? colors.clear : colors.dark
            },
            formatter: function(v, context){
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return value+'%';
            },
            font: {
              size: '10'
            },

          }
        },
        scales: {
              yAxes: [{
                ticks: {
                    beginAtZero: true,
                    max: bmax,
                    callback: function(v){
                      var label = v;
                          label = label +'%';
                      return label;
                    },
                    fontColor: colors.clear,
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                },
                display: false
              }],
              xAxes: [{
                ticks: {
                  maxRotation: is_desktop ? 0 : 90,
                  minRotation: is_desktop ? 0 : 40,
                  callback: function(v){
                    var label = v.toString();
                    if(label){
                      label = label.replace('60_', '60+');
                      label = label.replace(/\_/, ' a ');
                      // label = label.toUpperCase();
                    }

                    return label;
                  },
                  fontColor: colors.clear,
                  fontSize: 9
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                },
              }]
            }
        }
      }else{
        var options = {
        legend: false,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: function(context){
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              var label = labels[index];
              return label == highlight ? colors.clear : colors.dark
            },
            formatter: function(v, context){
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return value+'%';
            },
            font: {
              size: '7'
            },

          }
        },
        scales: {
              xAxes: [{
                ticks: {
                    max: m + 10,
                    beginAtZero: true,
                    callback: function(v){
                      var label = v;
                          label = label +'%';
                      return label;
                    },
                    fontColor: colors.clear,
                    display: false
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                },
                display: true
              }],
              yAxes: [{
                ticks: {
                  callback: function(v){
                    var label = v.toString();
                        label = label.replace('70_', '70+');
                        label = label.replace(/\_/, '-');
                        label = label.toUpperCase();
                    return label;
                  },
                  fontColor: colors.clear,
                  fontSize: 7
                },
                gridLines: {
                  color: function(i){
                    console.log('i', i);
                  }
                },
              }]
            }
        }
      }


      var chart = new Chart(ctx, {
        type: type,
        data: {
          labels: labels,
          datasets: [{
              data: data,
              backgroundColor:bgs
          }]
        },
        // plugins: [ChartLabels],
        options: options
      })


    }
  }

  render(){
    return(
      <div className="icc_graph icc_graph_flexed">
        {
          this.props.title ?
          <div className="icc_graph_title">
            {this.props.title}
          </div>
          : null
        }

        <div className="icc_graph_canvas icc_graph_canvas_line">
          <canvas id={"icc_graph_id_" + Math.random(99,99999)} ref={(ref) => this.canvas = ref}></canvas>

        </div>
        {
          this.props.l ?
          <div className="icc_graph_x_label">
            {this.props.l}
          </div>
            : null
        }
      </div>
    )
  }
}


class Form extends React.Component{
  state = {
    age: '',
    edo: '',
    gender: ''
  }

  componentDidMount(){
    this.t = null;
  }

  setAge(v){
    var self = this;
    v = parseInt(v);
    if(isNaN(v)){
      v = null;
    }
    this.setState({
      age: v
    })

    clearTimeout(this.t);

    this.t = setTimeout(function(){
      var v = self.state.age;
      if(v){
        v = Math.max(v, 18);
        v = Math.min(99, v);
        self.setState({
          age: v
        })
      }

    }, 2500)

  }

  setGender(g){
    this.setState({
      gender: g
    })
  }

  setEdo(g){
    this.setState({
      edo: g
    })
  }

  submit(){
    var obj = {
      gender: this.state.gender,
      edo: this.state.edo,
      age: this.state.age
    }

    this.props.onSubmit(obj);

  }

  render(){
    var valid = this.state.gender && !isNaN(this.state.age) && this.state.edo;
    return(
      <div className="interactivo_datos_form">
        <div className="interactivo_datos_form_tr">
          <div className="interactivo_form_td">
            <label>Edad</label>
            <input type="tel" min="0" max="99" value={this.state.age} onChange={(e) => this.setAge(e.target.value)}/>
          </div>
          <div className="interactivo_form_td">
            <label>sexo<span>*</span></label>
            <div className="interactivo_form_td_checkboxes">
              <div className="interactivo_form_td_checkboxes_checkbox">
                <input type="checkbox" value="mujer" onChange={(e) => this.setGender(e.target.value)} checked={this.state.gender == "mujer"}></input>
                <div className="interactivo_form_td_checkboxes_checkbox_c">
                  <div className="interactivo_form_td_checkboxes_checkbox_c_l">
                    Femenino
                  </div>
                </div>
              </div>
              <div className="interactivo_form_td_checkboxes_checkbox">
                <input type="checkbox" value="hombre" onChange={(e) => this.setGender(e.target.value)} checked={this.state.gender == "hombre"}></input>
                <div className="interactivo_form_td_checkboxes_checkbox_c">
                  <div className="interactivo_form_td_checkboxes_checkbox_c_l">
                    Masculino
                  </div>
                </div>
              </div>
            </div>
            <div className="interactivo_form_td_disclaimer"><span>*</span>La encuesta solo contempla datos de estos dos sexos.</div>
          </div>
        </div>
        <div className="interactivo_datos_form_tr">
          <div className="interactivo_form_td">
            <label>Estado</label>
            <div className="interactivo_form_td_select">
              <select onChange={(e) => this.setEdo(e.target.value)} value={this.state.edo}>
                <option value="">Selecciona tu estado</option>
                {
                  edos.map(function(edo){
                    return(
                      <option value={edo.code}>{edo.name}</option>
                    )
                  })
                }
              </select>
            </div>
          </div>
        </div>
        <div className="interactivo_datos_form_tr" id="interactivo_submit_tr">
          <div className="interactivo_form_td">
            <div className="interactivo_submit" disabled={!valid} onClick={() => this.submit()}>
              Comenzar
            </div>
          </div>
        </div>
        <div className="interactivo_datos_form_tr" id="interactivo_fuente">
          <div id="ifwjp">
            <span>Con información del</span>
            <img src={require('../../static/wjp.png')} />
          </div>
          Fuente: Módulo de Justicia Cotidiana de la Encuesta a Población General en México del World Justice Project, 2019.

        </div>
      </div>
    )
  }
}
